import React from 'react';

import { BreakdownSpendingsSectionWrapper } from './BreakdownSpendingSectionWrapper';
import { useBudgetBreakdownSpendingsQuery } from './hooks/useBudgetBreakdownSpendingsQuery';
import { type BreakdownPart } from '../../../../models/breakdown';
import { type SpendingType } from '../../../../models/breakdownSpending';
import { type ExpenseCategoryBreakdown } from '../../../../models/expenseCategoryBreakdown';
import { type PeriodRangePayload } from '../../../../models/periodRange';

type Props = {
  spendingType: SpendingType;
  budgetId: string;
  breakdownComputedAt: Date;
  periodRange: PeriodRangePayload;
  breakdownPart: BreakdownPart;
  expenseCategory?: ExpenseCategoryBreakdown['expenseCategory'];
};

export const BreakdownSpendingsSection = ({
  spendingType,
  breakdownPart,
  breakdownComputedAt,
  budgetId,
  periodRange,
  expenseCategory,
}: Props) => {
  const budgetBreakdownSpendingsQueryState = useBudgetBreakdownSpendingsQuery({
    budgetId,
    breakdownComputedAt,
    breakdownPart,
    spendingType,
    periodRange,
    expenseCategory,
  });
  return (
    <BreakdownSpendingsSectionWrapper
      queryState={budgetBreakdownSpendingsQueryState}
      spendingType={spendingType}
      breakdownPart={breakdownPart}
    />
  );
};
